import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducer.tsx';
import { entitlementServices } from '../utils/general/entitlementServices';

let store = createStore(rootReducer, applyMiddleware(thunk));
if (window.HTML_RENDITION.initialData.isStaticHtml){
    window.HTML_RENDITION.__PRELOADED_STATE__.asyncStateReducer.initialData = window.HTML_RENDITION.initialData;
    const entitlementServiceObj = entitlementServices(window.HTML_RENDITION.__PRELOADED_STATE__.asyncStateReducer.initialData.html_components_entitled, window.HTML_RENDITION.__PRELOADED_STATE__.asyncStateReducer.initialData.html_components_deaden);
    Object.assign(window.HTML_RENDITION.__PRELOADED_STATE__.asyncStateReducer.initialData, entitlementServiceObj);
    Object.assign(window.HTML_RENDITION.initialData, entitlementServiceObj);
    store = createStore(rootReducer, window.HTML_RENDITION.__PRELOADED_STATE__, applyMiddleware(thunk));
}

export default store;